const initialState = {
  company_details: {},
  entity_id: '',
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_COMPANY_DETAILS_REPORT_REDUCER': {
      return { ...state, company_details: action.data };
    }
    case 'SET_COMPANY_ENTITY_ID_REDUCER': {
      return { ...state, comapny_entity_id: action.data };
    }
    default:
      return state;
  }
};

export default reportReducer;
